import React, { useEffect, useRef } from 'react';
import { Container } from '@pixi/react';
import Button from '../button';
import { Spine } from '../../../core/classes/spine';

function GambleButton({
  x,
  y,
  spineKey,
  additionalImages,
  handleClickButton,
  animationName,
  skinName = 'heart',
}) {
  const spineRef = useRef();

  useEffect(() => {
    const spine = new Spine({ key: spineKey });
    spine.skeleton.setSkinByName(skinName);
    spine.play(animationName, true);
    spineRef.current.addChild(spine);
  }, [spineRef, spineKey, skinName, animationName]);

  return (
    <Button x={x} y={y} additionalImages={additionalImages} handleClickButton={handleClickButton}>
      <Container ref={spineRef} />
    </Button>
  );
}
export default GambleButton;
